/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'people.menu.renotify.flag.description': '我們正在透過電子郵件向每個人傳送提醒。這最多需要一分鐘的時間。',
  'people.menu.renotify.flag.description.confluence': '提醒團隊成員',
  'people.menu.renotify.flag.title': '正在傳送提醒',
  'people.menu.renotify.flag.title.confluence': '正在重新傳送邀請電子郵件',
  'people.menu.renotify.menu.description':
    '{userCount, plural, other {有 {userCount,number} 人尚未接受 {product} 的邀請。查看缺少的人員並向他們傳送提醒。}}',
  'people.menu.renotify.menu.description.confluence':
    '有些人員尚未接受 Confluence 的邀請。查看缺少的人員並向他們傳送提醒。',
  'people.menu.renotify.menu.dismiss': '關閉',
  'people.menu.renotify.menu.dismiss.confluence': '稍後再說',
  'people.menu.renotify.menu.remind': '提醒團隊成員',
  'people.menu.renotify.menu.remind.confluence': '提醒團隊成員',
  'people.menu.renotify.menu.title': '每個人都參與了嗎？',
  'people.menu.renotify.modal.copied': '連結已複製',
  'people.menu.renotify.modal.copy': '複製邀請連結',
  'people.menu.renotify.modal.description': '我們可以透過電子郵件將提醒傳送給缺席成員，您也可以自行分享邀請連結。',
  'people.menu.renotify.modal.description.confluence': '再次傳送邀請電子郵件，或複製並分享邀請連結。',
  'people.menu.renotify.modal.dismiss': '取消',
  'people.menu.renotify.modal.resend': '傳送提醒',
  'people.menu.renotify.modal.resend.confluence': '重新傳送邀請',
  'people.menu.renotify.modal.title': '提醒缺席成員',
  'people.menu.renotify.modal.title.confluence': '提醒缺少的團隊成員',
  'ptc.pm.collaborators.title': '您的共同作業者',
  'ptc.pm.error-heading': '發生錯誤',
  'ptc.pm.error-image-alt-text': '機器人故障，多位人員正在修復此問題。',
  'ptc.pm.error-text': '我們會持續追蹤這些錯誤，如果重新整理之後仍無法修復，您可以隨時與我們聯繫',
  'ptc.pm.num-members': '{memberCount, plural, other {{memberCount,number} 位成員}}',
  'ptc.pm.people': '人員',
  'ptc.pm.teams': '團隊',
  'ptc.pm.view-your-profile': '檢視您的設定檔',
  'ptc.pm.your-teams.title': '您的團隊',
};
